"use strict";

import vpData from './models/vp-meth';
import baData from './models/ba-meth';
import hoblData from './models/hobl-meth';
import drugData from './drugdata';
import State from './state';
import methods from './methods'

class DistPanel {

	constructor() {

		$('#d-menu').on(State.startEvent, (e)=>this.switchPage(e));
		$('.scr4-sw-line').on(State.startEvent, (e)=>this.switchType(e));
		$('#exit-butt').on(State.startEvent, this.hide);
		this.currSt = State.currStad;
		this.flEdit = 0;
	}

///////////////////////////////////

	show() {

		$('#distcont').show();		
		$('#section4').show();
		$('#main-cont').hide();		

	}

///////////////////////////////////

	hide() {

		if(State.flModal==1) return;
		if(this.flEdit==1) this.processInput(this.currElem);
		$('#main-cont').show();		
		$('#distcont').hide();		
		$('#section4').hide();		
	}

///////////////////////////////////

	renderSwitch() {

		if(State.clinType=='ds') {
			$('#sw-pict-day').addClass('bull-active');			
			$('#sw-pict-day').removeClass('bull-inactive');			
			$('#sw-pict-full').addClass('bull-inactive');			
			$('#sw-pict-full').removeClass('bull-active');			
			$('#sw-capt-day').addClass('mid-orange-txt');			
			$('#sw-capt-day').removeClass('mid-grey-txt');			
			$('#sw-capt-full').addClass('mid-grey-txt');			
			$('#sw-capt-full').removeClass('mid-orange-txt');			
		} else {
			$('#sw-pict-full').addClass('bull-active');			
			$('#sw-pict-full').removeClass('bull-inactive');			
			$('#sw-pict-day').addClass('bull-inactive');			
			$('#sw-pict-day').removeClass('bull-active');			
			$('#sw-capt-full').addClass('mid-orange-txt');			
			$('#sw-capt-full').removeClass('mid-grey-txt');			
			$('#sw-capt-day').addClass('mid-grey-txt');			
			$('#sw-capt-day').removeClass('mid-orange-txt');			
		}
	}

///////////////////////////////////

	switchType(e) {

		let type, newType;

		if(e.currentTarget.id=='sw-day') {
			if(State.clinType=='ds') return;
			newType = 'ds';
			State.clinicData = State.dsData;
		} else {
			if(State.clinType=='st') return;
			newType = 'st';			
			State.clinicData = State.stData;
		}
		if(this.flEdit==1) this.processInput(this.currElem);
		State.methPanel.saveMethData();
		State.clinType = newType;
		State.methPanel.loadMethData();
		this.renderSwitch();
		this.render();
		State.clinData.saveClinData();	
	}

///////////////////////////////////


	getPathData(pathReq) {

		let pathData, path;

		if(pathReq) path = pathReq;
		else path = State.currPath;

		if(path=='vp') pathData = vpData;
		else if(path=='ba') pathData = baData;
		else if(path=='hobl') pathData = hoblData;
		else console.log('!!! Error calling getPathData()');
		return pathData;
	}

///////////////////////////////////

	render(st) {

		const path = State.currPath;
		let pathData, colClass, tableLine, tableCode, methSet, drugs, methData,
			flOnls, alert, meth, size, cnt, visible, currDrug, omsVis, omsdVis, rloVis,
			omsPrice, omsdPrice, methPrice, OmsDrugBudget, OmsdDrugBudget,
			omsMethodBudget, omsdMethodBudget, nOfOmsPatients, nOfOmsdPatients,
			omsDelta, omsdDelta, omsPriceStr, omsdPriceStr, remPats, omsDeltaStr, 
			omsdDeltaStr, flAmbul = -1, flRlo = 1;

		if(st) this.currSt = st;
		pathData = this.getPathData();
		methSet = pathData[this.currSt].meth;
		flAmbul = pathData[this.currSt].ambul;
		if (typeof flAmbul === 'undefined') flAmbul = -1;
		if(path=='rl') this.allPats = State.rlFreePatsBuf[this.currSt];
		else if(path=='rmp') this.allPats = State.rmpFreePatsBuf[this.currSt];
		else {
			if(pathData[this.currSt].result != -1) this.allPats = pathData[this.currSt].result;
			else this.allPats = pathData[this.currSt].pats;	
		}
		const methTable = $('#scr4-insert');

		const len = methSet.length;
		let color = 0 ; 
		tableCode = '';
		let tarifOmsSumm = 0, deltaOmsSumm = 0;
		let tarifOmsdSumm = 0, deltaOmsdSumm = 0;
		for(let num=0 ; num<len ; num++) {
			meth = methSet[num];
			if(meth.oms===undefined) {
				meth.oms = 0;
				meth.omsd = 0;
				meth.rlo = 0;
				meth.onls = 0;
			}
			methData = methods[meth.meth];
			drugs = methData.drugs;
			size = drugs.length;
			flOnls = 1;
			for(cnt=0 ; cnt<size ; cnt++) {
				currDrug = drugData[drugs[cnt]];
//				if(currDrug.on == 0 || currDrug.inj == 1) { 
				if(currDrug.on == 0) { 
					flOnls = 0; 
					break; 
//					break; 
				}
			}
			if(flAmbul===0) { // Метод только в стационаре
				flOnls = 0; // В стационаре не может быть финансирования ОНЛС
				flRlo = 0; // В стационаре не может быть финансирования РЛО 
			}	

			if(path=='hobl') flRlo = 0; // Затраты на терапию ХОБЛ не могут относиться на региональное
										// льготное обеспечение

			if(methData.custKsg) {
				let custSet = State.calc.getCustomKSGSet(methData.custKsg, 'st');
				let custCnt, custLen = custSet.length;
				omsPrice = 0;
				for(custCnt=0 ; custCnt<custLen ; custCnt++) {
					omsPrice += this.calcMethodIncome(custSet[custCnt].code, custSet[custCnt].cyc);
				}	
				custSet = State.calc.getCustomKSGSet(methData.custKsg, 'ds');
				custLen = custSet.length;
				omsdPrice = 0;
				for(custCnt=0 ; custCnt<custLen ; custCnt++) {
					omsdPrice += this.calcMethodIncome(custSet[custCnt].code, custSet[custCnt].cyc);
				}	
			} else {
				omsPrice = this.calcMethodIncome(methData.st, meth.cycles[0]);
				omsdPrice = this.calcMethodIncome(methData.ds, meth.cycles[0]);
			}	

			omsPrice = Math.round(omsPrice*meth.oms);
			omsPriceStr = State.calc.padDigits(omsPrice);
			omsdPrice = Math.round(omsdPrice*meth.omsd);
			omsdPriceStr = State.calc.padDigits(omsdPrice);

			tarifOmsSumm += omsPrice;
			tarifOmsdSumm += omsdPrice;

			let drugSet = drugs;
			let doseSet = methData.dose;
			let nOfDrugs = drugSet.length;
			let nOfCycles = meth.cycles; // N of infusions for year 
										// for current method of therapy
			nOfOmsPatients = meth.oms;
			nOfOmsdPatients = meth.omsd;

			omsMethodBudget = 0;							
			omsdMethodBudget = 0;

			let drugIndex, cycleDose, currDrug, currPrice, drugDose, drugPack, 
			nOfPacks, nOfOmsPacks, nOfOmsdPacks;

			for(let currDrugN=0 ; currDrugN<nOfDrugs ; currDrugN++) {
				drugIndex = drugSet[currDrugN];
				cycleDose = doseSet[currDrugN];
				currDrug = drugData[drugIndex];

				currPrice = currDrug.price; // Price of one pack
				drugDose = currDrug.dose;	// Dose of one tablet or flask
				drugPack = currDrug.set;		// N of items in pack

				if(currDrug.tab) { // Таблетированная форма
					nOfPacks = Math.ceil(cycleDose/drugDose); // Таблеток на цикл
					nOfPacks = Math.ceil(nOfPacks*nOfCycles[currDrugN]/drugPack); // Пачек на курс
					nOfOmsPacks = nOfPacks*nOfOmsPatients // Пачек на курс на всех
					nOfOmsdPacks = nOfPacks*nOfOmsdPatients // Пачек на курс на всех
				}
				else {
					nOfPacks = Math.ceil(cycleDose/drugDose/drugPack); // Упаковок на цикл
					nOfOmsPacks = nOfOmsPatients*Math.ceil(nOfPacks*nOfCycles[currDrugN]);
					nOfOmsdPacks = nOfOmsdPatients*Math.ceil(nOfPacks*nOfCycles[currDrugN]);
				}
				nOfOmsPacks = Math.ceil(nOfOmsPacks);
				nOfOmsdPacks = Math.ceil(nOfOmsdPacks);
				OmsDrugBudget = nOfOmsPacks*currPrice;
				OmsdDrugBudget = nOfOmsdPacks*currPrice;
				omsMethodBudget += OmsDrugBudget;
				omsdMethodBudget += OmsdDrugBudget;
			}

			omsDelta = Math.round(omsPrice - omsMethodBudget);	
			omsDeltaStr = State.calc.padDigits(omsDelta);	
			omsdDelta = Math.round(omsdPrice - omsdMethodBudget);	
			omsdDeltaStr = State.calc.padDigits(omsdDelta);	
			deltaOmsSumm += omsDelta;
			deltaOmsdSumm += omsdDelta;

			remPats = meth.pats - meth.oms - meth.omsd - meth.rlo - meth.onls;

			if(flOnls) visible = ''; else visible = 'style="display:none"';	
			if(flRlo) rloVis = ''; else rloVis = 'style="display:none"';	
			alert = '';
			if(methData.st==undefined || methData.st=='' || flAmbul==1) omsVis = 'style="display:none"'; else omsVis = '';	
			if(methData.ds==undefined || methData.ds=='' || flAmbul==1) omsdVis = 'style="display:none"'; else omsdVis = '';	

			if(color==0) colClass = 'grey'; else colClass = '';
			tableLine = `
            <div class="scr4-line" id="scr4-line${num}">
                <div class="scr4-col d-col1 ${colClass}" id="col1-line${num}">
    				${methData.name}<br>
    				<span class="scr4-info">${methData.info}</span>
                </div>
                <div class="scr4-data-col d-col2 ${colClass}" id="col2-line${num}"><span class="p-capt">П-тов:</span> ${remPats}</div>
                <div class="scr4-data-col d-col3 ${colClass}" id="col3-line${num}">
        	        <input ${omsVis} class="oms-input" id="oms-input${num}" type="text" value="${meth.oms}">	
                </div>
                <div class="scr4-data-col d-col4 ${colClass}" id="col4-line${num}">
        		    <input ${omsdVis} class="omsd-input" id="omsd-input${num}" type="text" value="${meth.omsd}">	
                </div>
                <div class="scr4-data-col d-col5 ${colClass}" id="col5-line${num}">
        		    <input ${rloVis} class="rlo-input" id="rlo-input${num}" type="text" value="${meth.rlo}">	
                </div>
                <div class="scr4-data-col d-col6 ${colClass}" id="col6-line${num}">
        		    <input ${visible} class="onls-input" id="onls-input${num}" type="text" value="${meth.onls}">	
                </div>
            </div>
            <div class="scr4-bot-line" id="scr4-bot-line${num}">
                <div class="scr4-tcap db-col1 ${colClass}">
					Тариф КСГ/Тариф КСГ-ЛП
                </div>
                <div class="scr4-data-col db-col2 ${colClass}"></div>
                <div class="db-col3 ${colClass}" id="col3-bot-line${num}">
                	<span id="scr4-oms-tarif${num}">${omsPriceStr}</span>/<br>
                	<span id="scr4-oms-delta${num}">${omsDeltaStr}</span>&nbsp;
                </div>
                <div class="db-col4 ${colClass}" id="col4-bot-line${num}">
                	<span id="scr4-omsd-tarif${num}">${omsdPriceStr}</span>/<br>
                	<span id="scr4-omsd-delta${num}">${omsdDeltaStr}</span>&nbsp;
                </div>
                <div class="scr4-data-col db-col5 ${colClass}">
                </div>
                <div class="scr4-data-col db-col6 ${colClass}">
                </div>
            </div>
			`;
			tableCode += tableLine;
			color++;
			if(color>1) color = 0;
		}
		methTable.empty();
		methTable.append(tableCode);
		$('.oms-input').on(State.startEvent, (e)=>this.selectEdit(e));
		$('.omsd-input').on(State.startEvent, (e)=>this.selectEdit(e));
		$('.rlo-input').on(State.startEvent, (e)=>this.selectEdit(e));
		$('.onls-input').on(State.startEvent, (e)=>this.selectEdit(e));
		$('.oms-input').on('keypress', (e) => this.editNumber(e));
		$('.omsd-input').on('keypress', (e) => this.editNumber(e));
		$('.rlo-input').on('keypress', (e) => this.editNumber(e));
		$('.onls-input').on('keypress', (e) => this.editNumber(e));
		$('.oms-input').on('focusout', (e) => this.focusOut(e));
		$('.omsd-input').on('focusout', (e) => this.focusOut(e));
		$('.rlo-input').on('focusout', (e) => this.focusOut(e));
		$('.onls-input').on('focusout', (e) => this.focusOut(e));

		tarifOmsSumm = State.calc.padDigits(Math.round(tarifOmsSumm));
		tarifOmsdSumm = State.calc.padDigits(Math.round(tarifOmsdSumm));
		$('#omsTarSumm').text(tarifOmsSumm);
		$('#omsdTarSumm').text(tarifOmsdSumm);

		deltaOmsSumm = State.calc.padDigits(Math.round(deltaOmsSumm));
		deltaOmsdSumm = State.calc.padDigits(Math.round(deltaOmsdSumm));
		$('#omsDeltaSumm').text(deltaOmsSumm);
		$('#omsdDeltaSumm').text(deltaOmsdSumm);
		this.renderTotals();
		this.renderSwitch();
	}

///////////////////////////////////

	renderTotals(reqPath, reqSt) {

		let res, path, st, rem;

		if(State.clinType=='st') State.clinicData = State.stData;
		if(State.clinType=='ds') State.clinicData = State.dsData;
		if(reqPath) path = reqPath; else path = State.currPath;
		if(reqSt) st = reqSt; else st = State.currStad;

		res = Math.round(State.calc.calcOneGroup(path, st, 'oms')); 
		$('#scr4-hcol2-line3').text(State.calc.padDigits(res));

		res = Math.round(State.calc.calcFullBudget('oms')); 
		rem = State.clinicData.omsPlan - res;
		$('#scr4-hcol2-line2').text(State.calc.padDigits(rem));
		if(rem<0) {
			$('#scr4-hcol2-line2').addClass('alert');
			$('#scr4-hcol2-line2').removeClass('white');
		}
		else {
			$('#scr4-hcol2-line2').removeClass('alert');
			$('#scr4-hcol2-line2').addClass('white');
		}


		res = Math.round(State.calc.calcOneGroup(path, st, 'omsd')); 
		$('#scr4-hcol3-line3').text(State.calc.padDigits(res));

		res = Math.round(State.calc.calcFullBudget('omsd')); 
		rem = State.clinicData.omsdPlan - res;
		$('#scr4-hcol3-line2').text(State.calc.padDigits(rem));
		if(rem<0) {
			$('#scr4-hcol3-line2').addClass('alert');
			$('#scr4-hcol3-line2').removeClass('white');
		}
		else {
			$('#scr4-hcol3-line2').removeClass('alert');
			$('#scr4-hcol3-line2').addClass('white');
		}

		res = Math.round(State.calc.calcOneGroup(path, st, 'rlo')); 
		$('#scr4-hcol4-line3').text(State.calc.padDigits(res));

		res = Math.round(State.calc.calcFullBudget('rlo')); 
		rem = State.clinicData.rloPlan - res;
		$('#scr4-hcol4-line2').text(State.calc.padDigits(rem));
		if(rem<0) {
			$('#scr4-hcol4-line2').addClass('alert');
			$('#scr4-hcol4-line2').removeClass('white');
		}
		else {
			$('#scr4-hcol4-line2').removeClass('alert');
			$('#scr4-hcol4-line2').addClass('white');
		}
		res = Math.round(State.calc.calcOneGroup(path, st, 'onls')); 
		$('#scr4-hcol5-line3').text(State.calc.padDigits(res));

		res = Math.round(State.calc.calcFullBudget('onls')); 
		rem = State.clinicData.onlsPlan - res;
		$('#scr4-hcol5-line2').text(State.calc.padDigits(rem));
		if(rem<0) {
			$('#scr4-hcol5-line2').addClass('alert');
			$('#scr4-hcol5-line2').removeClass('white');
		}
		else {
			$('#scr4-hcol5-line2').removeClass('alert');
			$('#scr4-hcol5-line2').addClass('white');
		}
// Patients remained for distribution into onls and rlo chanels		
		let patsRemain = State.repPatsNum[path] - State.nOfRloPats[path] - State.nOfOnlsPats[path]; 
		$('#pats-remain').text(State.calc.padDigits(patsRemain));
		State.nOfRemained[path] = patsRemain;
// Clinic plan
		$('#scr4-hcol2-line1').text(State.calc.padDigits(State.clinicData.omsPlan));
		$('#scr4-hcol3-line1').text(State.calc.padDigits(State.clinicData.omsdPlan));
		$('#scr4-hcol4-line1').text(State.calc.padDigits(State.clinicData.rloPlan));
		$('#scr4-hcol5-line1').text(State.calc.padDigits(State.clinicData.onlsPlan));

// OMS income		
		$('#total-oms-income').text(State.calc.padDigits(Math.round(State.stIncome + State.dsIncome)));
//console.log(State.stIncome);
		if(State.nOfCasesKs!=0)	State.averCostKs = State.stIncome/State.nOfCasesKs;
		else State.averCostKs = 0;
		if(State.nOfCasesDs!=0)	State.averCostDs = State.dsIncome/State.nOfCasesDs;
		else State.averCostDs = 0;

// Page 6 chanel table
		$('#scr6-insert').html('');
		State.chanTable.render('');
		State.chanTable.render('oms');
		State.chanTable.render('omsd');
		State.chanTable.render('rlo');
		State.chanTable.render('onls');

	}

///////////////////////////////////

	resetGroupChanels(methSet) {

		let meth, clinTypeBackup = State.clinType;

		const len = methSet.length;
		for(let num=0 ; num<len ; num++) {
			meth = methSet[num];
				meth.oms = 0;
				meth.omsd = 0;
				meth.rlo = 0;
				meth.onls = 0;
		}
//!!TODO >>>>>>> Нужно сделать процедуру сохранения одной группы !!
		State.clinType = 'st'; State.methPanel.saveMethData();
		State.clinType = 'ds'; State.methPanel.saveMethData();
		State.clinType = clinTypeBackup;
	}

///////////////////////////////////

	resetChanels(reqSt) {

		let pathData, methSet, meth;

//console.log('resetGroupChanels');
		const path = State.currPath;
		let st; 

		if(reqSt) st = reqSt;
		else st = State.currStad;

		this.currSt = st;
		pathData = this.getPathData();
		methSet = pathData[st].meth;
		this.resetGroupChanels(methSet);
		this.render(st);
	}

///////////////////////////////////

	resetPathChanels(path) {

//console.log('resetPathChanels: '+ path);
		let pathData, st, methSet;

		pathData = this.getPathData(path);
		for (st in pathData) {
			methSet = pathData[st].meth;
			this.resetGroupChanels(methSet);
		}
	}

///////////////////////////////////

	resetAllChanels() {

		let path, len;
//console.log('resetAllChanels');
		for(let i=0, len=State.pathKeys.length ; i<len ; i++)
			this.resetPathChanels(State.pathKeys[i]);
	}

///////////////////////////////////

	selectEdit(e) {

		let el = e.target.id;

		this.flEdit = 1;	
		this.currElem = el;
		setTimeout(() => {
			$('#'+el).focus();
			let len = $('#'+el).val().length;
			let inp = document.getElementById(el);
			inp.setSelectionRange(0,len);
		},100);
	}

///////////////////////////////////

	processInput(el) {

		let lineNum, pathData, chan, oldValue, 
			methData, delta, newVal, groupData, patsVal, 
			val = $('#'+el).val();

		this.flEdit = 0;	
		if(-1 < el.indexOf('oms-input')) {
			chan = 'oms';
			lineNum = el.slice(9);
		}
		if(-1 < el.indexOf('omsd-input')) {
			chan = 'omsd';
			lineNum = el.slice(10);
		}
		if(-1 < el.indexOf('rlo-input')) {
			chan = 'rlo';
			lineNum = el.slice(9);
		}
		if(-1 < el.indexOf('onls-input')) {
			chan = 'onls';
			lineNum = el.slice(10);
		}
		pathData = this.getPathData();
		groupData = pathData[this.currSt];
		methData = groupData.meth[lineNum];
		if(chan=='oms') oldValue = methData.oms;
		if(chan=='omsd') oldValue = methData.omsd;
		if(chan=='rlo') oldValue = methData.rlo;
		if(chan=='onls') oldValue = methData.onls;
		delta = val - oldValue;
		patsVal = methData.pats - methData.oms - methData.omsd - methData.rlo - methData.onls;
		if((chan=='rlo' || chan=='onls') 
			&& (State.nOfRemained[State.currPath] - delta)<0) {
			delta = State.nOfRemained[State.currPath];
			alert('Вы пытаетесь распределить в каналы ОНЛС и РЛО больше пациентов, чем задано на странице "Параметры заявки"!');
		}
		if((patsVal-delta)<0) {
			newVal = oldValue + patsVal; 
			patsVal = 0;
		} else {
			newVal = oldValue + delta;
			patsVal -= delta;
		}
		if(chan=='oms') methData.oms = newVal;
		if(chan=='omsd') methData.omsd = newVal;
		if(chan=='rlo') methData.rlo = newVal;
		if(chan=='onls') methData.onls = newVal;
		$('#'+el).val(newVal);
		$('#col2-line'+lineNum).text(patsVal);
		State.calc.calcFullBudget();
//TODO сделать целевой рефреш в текущей строке
this.render();
//		this.renderTotals();
		State.methPanel.saveMethData();
	}

///////////////////////////////////

	focusOut(e) {

		let el = e.target.id, lineNum;

		this.processInput(el);
	}


///////////////////////////////////

	editNumber(e) {

		if(e.type=='keypress') {
			if(e.charCode==13) {
				this.processInput(e.target.id);
				return;
			}
			if(e.charCode<48 || e.charCode>57) {
				e.preventDefault();
				return;
			}
		}
		// if(e.type=='focusout') {
		// 		this.completeEdit('out');
		// }	
	}


///////////////////////////////////

	calcMethodIncome(code, cycles) {

		let type, kz, res, clinData, ksgNum, customUK;
		const stInd = {
			'st12.013': 0, 
			'st23.004': 1,
			'st23.005': 2,
			'st36.003': 3
		};
		const dsInd = {
			'ds23.001': 0,
			'ds36.004': 1
		};

		if(code=='') return 0;
		if(code==undefined) return 0;
		kz = this.getKsgValue(code);
		ksgNum = code.slice(6);
		ksgNum = parseInt(ksgNum);		
		if(-1 != code.indexOf('ds')) {
			ksgNum = dsInd[code]; 
			customUK = State.dsUKData[ksgNum];
			clinData = State.dsData;
		}
		else if(-1 != code.indexOf('st')) {
			ksgNum = stInd[code];; 
			customUK = State.stUKData[ksgNum];
			clinData = State.stData;
		}
		else return 0;
		if(customUK==-1) {
			res = clinData.bs*kz*clinData.kus*clinData.uk*clinData.kslp*clinData.kd;
		} else {
			res = clinData.bs*kz*clinData.kus*customUK*clinData.kslp*clinData.kd;
		}
		if(cycles) {
			cycles = Math.ceil(cycles);
			res = res*cycles;
		}
		res = Math.round(res);
		return res;
	}


///////////////////////////////////

	getKsgValue(ksg) {

		let val = 0;

		if(ksg=='ds23.001') val = 0.9;
		if(ksg=='ds36.004') val = 9.74;

		if(ksg=='st12.013') val = 4.4;
		if(ksg=='st23.004') val = 1.28;
		if(ksg=='st23.005') val = 1.11;
		if(ksg=='st36.003') val = 5.35;

		return val;
	}

///////////////////////////////////

	switchPage(e) {

	        var target, adrStr, hideSection, str;
	        if(State.flAnimate>0) return;
	        if(State.flSelection>0) return;
	        if(State.flModal==1) return;
	        hideSection = '#section' + State.distCurrPage;
	        target = e.target.id;
	        str = target.slice(0,9);
	        if(str=='print-but') {
	        	e.preventDefault();
	        	State.printer.dataPrint();
	        }
	        if(str!='menu-butt') return;
	        target = target.slice(-1);

	        if(target==State.distCurrPage) return;
	        State.flAnimate = 2;
	        $('#menu-butt'+State.distCurrPage).addClass('inactive');
	        $('#menu-butt'+State.distCurrPage).removeClass('active');
	        $('#menu-butt'+target).addClass('active');
	        $('#menu-butt'+target).removeClass('inactive');
	        $('#section'+target).css({'opacity':0, 'display':'block'});
	        $('#section'+target).animate({'opacity':1}, 700, function(){
	            State.flAnimate--;
	        });
	        $(hideSection).animate({'opacity':0}, 700, function(){
	            $(hideSection).css({'display':'none'});
	            State.distCurrPage = target;
	            State.flAnimate--;
	        });
	}

///////////////////////////////////


}

export default DistPanel;